import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CustomerLayout } from '../../components/layouts/CustomerLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { CreditCard, ShieldCheck, AlertCircle } from 'lucide-react';
import { toPersianDigits, formatCurrency } from '../../utils/persian';
export function CheckoutPage() {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);
  const handlePayment = () => {
    setIsProcessing(true);
    // Mock payment gateway delay
    setTimeout(() => {
      setIsProcessing(false);
      navigate('/dashboard');
      alert('پرداخت با موفقیت انجام شد! بیمه‌نامه شما صادر گردید.');
    }, 2000);
  };
  return <CustomerLayout data-id="element-259">
      <div className="max-w-4xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-260">
        {/* Order Summary */}
        <div className="lg:col-span-2 space-y-6" data-id="element-261">
          <Card data-id="element-262">
            <CardHeader data-id="element-263">
              <CardTitle className="text-lg" data-id="element-264">اطلاعات بیمه‌گذار</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4" data-id="element-265">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-266">
                <Input label="نام و نام خانوادگی" value="علی احمدی" readOnly data-id="element-267" />
                <Input label="کد ملی" value={toPersianDigits('1234567890')} readOnly data-id="element-268" />
                <Input label="شماره موبایل" value={toPersianDigits('09123456789')} readOnly data-id="element-269" />
                <Input label="آدرس" value="تهران، خیابان ولیعصر..." data-id="element-270" />
              </div>
            </CardContent>
          </Card>

          <Card data-id="element-271">
            <CardHeader data-id="element-272">
              <CardTitle className="text-lg" data-id="element-273">درگاه پرداخت</CardTitle>
            </CardHeader>
            <CardContent data-id="element-274">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-275">
                <div className="border rounded-lg p-4 flex flex-col items-center justify-center cursor-pointer hover:border-primary hover:bg-primary/5 transition-colors border-primary bg-primary/5" data-id="element-276">
                  <CreditCard className="h-8 w-8 mb-2 text-primary" data-id="element-277" />
                  <span className="text-sm font-medium" data-id="element-278">درگاه سامان</span>
                </div>
                <div className="border rounded-lg p-4 flex flex-col items-center justify-center cursor-pointer hover:border-primary hover:bg-primary/5 transition-colors" data-id="element-279">
                  <CreditCard className="h-8 w-8 mb-2 text-gray-400" data-id="element-280" />
                  <span className="text-sm font-medium" data-id="element-281">درگاه ملت</span>
                </div>
                <div className="border rounded-lg p-4 flex flex-col items-center justify-center cursor-pointer hover:border-primary hover:bg-primary/5 transition-colors" data-id="element-282">
                  <CreditCard className="h-8 w-8 mb-2 text-gray-400" data-id="element-283" />
                  <span className="text-sm font-medium" data-id="element-284">درگاه پارسیان</span>
                </div>
              </div>

              <div className="mt-6 bg-yellow-50 border border-yellow-200 rounded-lg p-4 flex gap-3" data-id="element-285">
                <AlertCircle className="h-5 w-5 text-yellow-600 flex-shrink-0" data-id="element-286" />
                <p className="text-sm text-yellow-700" data-id="element-287">
                  با پرداخت این مبلغ، بیمه‌نامه شما به صورت آنی صادر شده و نسخه
                  الکترونیکی آن قابل دانلود خواهد بود.
                </p>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Sidebar Summary */}
        <div className="lg:col-span-1" data-id="element-288">
          <Card className="sticky top-6" data-id="element-289">
            <CardHeader className="bg-gray-50 border-b" data-id="element-290">
              <CardTitle className="text-lg" data-id="element-291">خلاصه سفارش</CardTitle>
            </CardHeader>
            <CardContent className="p-6 space-y-4" data-id="element-292">
              <div className="flex items-center gap-3 mb-4" data-id="element-293">
                <div className="h-10 w-10 rounded-lg bg-blue-100 flex items-center justify-center text-blue-600" data-id="element-294">
                  <ShieldCheck className="h-6 w-6" data-id="element-295" />
                </div>
                <div data-id="element-296">
                  <h3 className="font-bold text-gray-900" data-id="element-297">بیمه شخص ثالث</h3>
                  <p className="text-sm text-gray-500" data-id="element-298">بیمه پاسارگاد</p>
                </div>
              </div>

              <div className="space-y-2 text-sm border-t pt-4" data-id="element-299">
                <div className="flex justify-between text-gray-600" data-id="element-300">
                  <span data-id="element-301">قیمت پایه</span>
                  <span data-id="element-302">{formatCurrency(4000000)}</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-303">
                  <span data-id="element-304">مالیات و عوارض</span>
                  <span data-id="element-305">{formatCurrency(200000)}</span>
                </div>
                <div className="flex justify-between text-green-600 font-medium" data-id="element-306">
                  <span data-id="element-307">تخفیف</span>
                  <span data-id="element-308">{formatCurrency(0)}</span>
                </div>
              </div>

              <div className="border-t pt-4 mt-4" data-id="element-309">
                <div className="flex justify-between items-center mb-6" data-id="element-310">
                  <span className="font-bold text-gray-900" data-id="element-311">
                    مبلغ قابل پرداخت
                  </span>
                  <span className="font-bold text-xl text-primary" data-id="element-312">
                    {formatCurrency(4200000)}
                  </span>
                </div>
                <Button className="w-full h-12 text-lg" onClick={handlePayment} isLoading={isProcessing} data-id="element-313">
                  پرداخت آنلاین
                </Button>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </CustomerLayout>;
}